import { render, staticRenderFns } from "./Clone.vue?vue&type=template&id=2b4ef9e2&scoped=true&"
import script from "./Clone.vue?vue&type=script&lang=js&"
export * from "./Clone.vue?vue&type=script&lang=js&"
import style0 from "./Clone.vue?vue&type=style&index=0&id=2b4ef9e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4ef9e2",
  null
  
)

export default component.exports